import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=35aed5b9&scoped=true&"
import script from "./DeviceDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=35aed5b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aed5b9",
  null
  
)

export default component.exports